/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropertiesCreatedLastMonth200ResponseMeta } from './propertiesCreatedLastMonth200ResponseMeta';
import { PropertiesCreatedLastMonthResource } from './propertiesCreatedLastMonthResource';


export interface PropertiesCreatedLastMonth200Response { 
    data: PropertiesCreatedLastMonthResource;
    meta: PropertiesCreatedLastMonth200ResponseMeta;
}

